import React, { useReducer, useState, useEffect } from "react";
import Input from "../../../../Input/Input";
import CustomButton from "../../../../Button/CustomButton.tsx";
import Preloader from "../../../../Preloader/Preloader.jsx";
import Toast from "../../../../Toast/Toast.jsx";
import { useAuth } from "../../../../../context/AuthContext.jsx";
import { StyledModalcomponentClientes } from "../../../Styled.jsx";
import {
  getClienteOptions,
  updateEquipos,
  createEquipos,
  getPlantaOptionsWithCliente,
} from "../../../../../api/Clientes.js";
import { getPlantaOptionsByClienteEquipos } from "../../../../../api/Muestras.ts";
const EquiposModal = (props) => {
  const { token } = useAuth();

  const propsEquipos = (datosUnidades) => {
    const ver = datosUnidades?.button === "ver" ?? false;
    const editar = datosUnidades?.button === "editar" ?? false;
    const datos = datosUnidades?.datos ?? [];
    return { ver, editar, datos };
  };
  const { ver, editar, datos } = propsEquipos(props.datos);

  const [formCompleto, setFormCompleto] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [msjToast, setMsjToast] = useState("");
  const [clientes, setClientes] = useState([]);
  const [plantas, setPlantas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [selectedOptioncli, setSelectedOptioncli] = useState(null);
  const [selectedOptionpla, setSelectedOptionpla] = useState(null);

  const [form, setForm] = useReducer(
    (state, action) => {
      switch (action.type) {
        case "SET_FIELD":
          return { ...state, [action.field]: action.value };
        default:
          return state;
      }
    },
    {
      id: datos.id ?? "",
      cliente: datos.cliente ?? "",
      planta: datos.planta ?? "",
      plantaId: datos.plantaId ?? "",
      codigo: datos.codigo ?? "",
      denominacion: datos.denominacion ?? "",
      tagPlanta: datos.tagplanta ?? "",
      area: datos.area ?? "",
      selectedOption: props.datos.selectedOption ?? "",
    }
  );

  
  useEffect(() => {
    const fetchData = async () => {

      const resClientes = await getClienteOptions();
      const clientesMapped = resClientes?.data?.map((item) => ({
        value: item.id,
        label: item.desc_cli,
      })) ?? [];
      setClientes(clientesMapped);


      let clienteSeleccionado = clientesMapped.find(c => c.value === datos?.clienteId);
      if (!clienteSeleccionado && datos?.clienteId) {
        clienteSeleccionado = { value: datos.clienteId, label: datos.cliente, estado: "eliminado" };
      }

      if (clienteSeleccionado) {
        setSelectedOptioncli(clienteSeleccionado);
        setForm({ type: "SET_FIELD", field: "cliente", value: clienteSeleccionado.value });
      }


      let plantaId = datos?.plantaId;
      if (props?.datos?.selectedOption?.value) {
        plantaId = props.datos.selectedOption.value;
      }


      if (!clienteSeleccionado?.value && !plantaId) return;

      const clienteParaPlanta = clienteSeleccionado?.value || selectedOptioncli?.value;

      const resPlantas = clienteParaPlanta ? await getPlantaOptionsByClienteEquipos(clienteParaPlanta) : await getPlantaOptionsWithCliente();
      const plantasMapped = Array.isArray(resPlantas?.data)
        ? resPlantas.data.map((item) => ({
          value: item.id,
          label: item.desc_pla,
          cliente: item.cliente,
        }))
        : [];
      setPlantas(plantasMapped);


      let plantaSeleccionada = plantasMapped.find(p => p.value === plantaId);
      if (plantaSeleccionada) {
        setSelectedOptionpla(plantaSeleccionada);
        setForm({ type: "SET_FIELD", field: "planta", value: plantaSeleccionada.value });
        setForm({ type: "SET_FIELD", field: "plantaId", value: plantaSeleccionada.value });


        if (!clienteSeleccionado && plantaSeleccionada.cliente?.id) {
          const clienteAuto = {
            value: plantaSeleccionada.cliente.id,
            label: plantaSeleccionada.cliente.description,
          };
          setSelectedOptioncli(clienteAuto);
          setForm({ type: "SET_FIELD", field: "cliente", value: clienteAuto.value });
        }
      } else if (plantaId) {
        setSelectedOptionpla({
          label: datos?.planta || "Planta desconocida",
          value: plantaId,
          estado: "eliminado",
        });
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    const campoValido = (campo) => form[campo] !== "";
    //plantaid
    const camposaValidar = [
      "cliente",
      "denominacion",
      "plantaId",
    ];
    const formularioCompleto = camposaValidar.every(campoValido);
    setFormCompleto(formularioCompleto);
  }, [form]);

  useEffect(() => {
    if (selectedOptioncli !== "" && selectedOptioncli !== null && !ver) {
      if (!selectedOptioncli?.value) return;
      getPlantaOptionsByClienteEquipos(selectedOptioncli.value).then((res) => {
        setPlantas(
          res.data.map((res) => {

            return { label: res.desc_pla, value: res.id, subLabel: res.cliente.description, };

          })
        );
        // setEquipos([])
      });
    }
  }, [selectedOptioncli]);

  useEffect(() => {
    if (token?.rol === "TENANT" || clientes.length === 0 || selectedOptioncli) return;

    const match =
      clientes.find((c) => c.value === parseInt(token?.clienteId, 10)) ||
      clientes.find((c) => c.value === datos?.cliente || c.label === datos?.cliente);

    if (match) {
      setSelectedOptioncli(match);
      setForm({ type: "SET_FIELD", field: "cliente", value: match.value });
    } else if (datos?.cliente) {
      setSelectedOptioncli({
        label: datos.clienteDesc || datos.cliente,
        value: datos.clienteId || datos.cliente,
        estado: "eliminado",
      });
      setForm({
        type: "SET_FIELD",
        field: "cliente",
        value: datos.clienteId || datos.cliente,
      });
    }
  }, [clientes, selectedOptioncli, token?.rol]);

  const handleChange = (e, nameReactSelect) => {
    if (e.target) {
      const { name, value, checked, type } = e.target;
      const fieldValue = type === "checkbox" ? checked : value;
      setForm({ type: "SET_FIELD", field: name, value: fieldValue });
    } else {
      const value = e.value;
      const name = nameReactSelect;
      const label = e.label;

      if (name === "cliente") {
        // El cliente no se guarda, solo sirve para obtener las plantas.
        setSelectedOptionpla('');
        setSelectedOptioncli(e);
        setForm({ type: "SET_FIELD", field: name, value: label });
        setForm({ type: "SET_FIELD", field: "plantaId", value: "" })
      } else if (name === "plantaId") {
        //REVISAR ACA
        setSelectedOptionpla(e);
        setForm({ type: "SET_FIELD", field: name, value: value });
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    let formattedData = {
      id: form.id ? form.id : 0,
      codigo_equi: form.codigo,
      desc_equi: form.denominacion,
      tag_externo_equi: form.tagPlanta,
      area_equi: form.area,
      tipo_equi_id: "32132",
      planta_id: parseInt(form.plantaId),
      created_by: "dasfdasd",
      created_date: new Date(),
      last_modified_by: "1",
      last_modified_date: new Date(),
      status: "SI",
      eliminado: false,
      tenantId: "1",
    };

    if (editar) {
      updateEquipos(formattedData)
        .then((res) => {
          setIsLoading(false);
          props.onClick({
            msj: "Equipo modificado con exito.",
            status: "success",
          });
        })
        .catch((err) => {
          setIsLoading(false);
          props.onClick({
            msj: "No se Pudo modificar el equipo.",
            status: "error",
          });
        });
    } else {
      createEquipos(formattedData)
        .then((res) => {
          setIsLoading(false);
          props.onClick({
            msj: "Equipo creado con exito.",
            status: "success",
          });
        })
        .catch((err) => {
          setIsLoading(false);
          props.onClick({
            msj: "No se pudo crear el equipo.",
            status: "error",
          });
        });
    }
  };

  const titulo = () => {
    const titulo = ver
      ? "Ver equipo"
      : editar
        ? "Editar equipo"
        : "Crear o editar equipos";
    return titulo;
  };

  const renderButtons = () => {
    return (
      <>
        <CustomButton
          onClick={props.onClick}
          label={ver ? "Cerrar" : "Cancelar"}
          variant="contained"
          className={`buttonColor${ver ? "Default" : "Disabled"} btn`}
        />
        {!ver && (
          <CustomButton
            label={"Confirmar"}
            variant="contained"
            className={`buttonColorDefault btn`}
            type="submit"
            disabled={!selectedOptioncli || !formCompleto || (selectedOptioncli.estado && selectedOptioncli.estado === "eliminado")}
          // disabled={!editar ? !formCompleto : selectedOptionpla === '' ? true : false}
          />
        )}
      </>
    );
  };

  return (
    <StyledModalcomponentClientes>
      <Preloader
        title="Cargando..."
        subtitle={"Espere unos Segundos por favor..."}
        loading={isLoading}
      />
      <div classname="toast">
        {success ? (
          <Toast title={msjToast} close={() => setSuccess(false)} />
        ) : null}
        {error ? (
          <Toast
            type={"error"}
            title={
              "Error al " + (editar ? "modificar" : "crear") + "la unidad ?"
            }
            close={() => setError(false)}
          />
        ) : null}
      </div>

      <div className="equipos">
        <div className="divLabel">
          <p className="titulo"> {titulo()} </p>
        </div>
        <div className="divInputsItem">
          <form className="formulario" onSubmit={handleSubmit}>
            <div className="divUno d-flex ">
              <div style={{ width: "50%" }}>
                <Input
                  reactSelect
                  options={clientes}
                  value={selectedOptioncli}
                  onChange={(e) => {
                    handleChange(e, "cliente");
                  }}
                  isDisabled={(ver && true) || token.clienteId !== ""}
                  placeholder={
                    ver ? "Cliente" : "Seleccione el cliente"
                  }
                />
                {selectedOptioncli && selectedOptioncli.estado === "eliminado" ? <p className="p-0 m-0 " style={{ margin: "0px", fontStyle: "italic", fontWeight: "bold", color: "red" }}>**cliente eliminado, elegir otro**</p> : null}
              </div>
              <div style={{ width: "50%" }}>
                <Input
                  reactSelect
                  options={plantas}
                  value={selectedOptionpla}
                  onChange={(e) => {
                    handleChange(e, "plantaId");
                  }}
                  isDisabled={
                    datos.length === 0 && form.cliente === "" ? true : ver
                  }
                  placeholder={
                    ver ? "Planta" : editar ? "Seleccione la planta" : form.cliente === ""
                      ? "Seleccione un cliente primero"
                      : "Seleccione la planta"
                  }
                  showSubLabel
                />
                {selectedOptionpla && selectedOptionpla.estado === "eliminado" ? <p className="p-0 m-0 " style={{ margin: "0px", fontStyle: "italic", fontWeight: "bold", color: "red" }}>**planta eliminada**</p> : null}
              </div>
            </div>
            <div className="divDos d-flex divs">
              {ver || editar ? (
                <Input
                  value={form.codigo}
                  label="Código"
                  classnamediv="divCodigo divInput"
                  className="input inputCodigo"
                  variant="outlined"
                  size={"medium"}
                  name="codigo"
                  onChange={handleChange}
                  disabled={true}
                />
              ) : (
                <></>
              )}
              <Input
                value={form.denominacion}
                label="Denominación"
                classnamediv="divDenominacion divInput"
                className="input inputDenominacion"
                variant="outlined"
                size={"medium"}
                name="denominacion"
                onChange={handleChange}
                disabled={ver && true}
              />
            </div>
            <div className="divTres d-flex divs">
              <Input
                value={form.tagPlanta}
                label="TAG Planta"
                classnamediv="divTagPlanta divInput"
                className="input inputTagPlanta"
                variant="outlined"
                size={"medium"}
                name="tagPlanta"
                onChange={handleChange}
                disabled={ver && true}
              />
              <Input
                value={form.area}
                label="Area"
                classnamediv="divArea divInput"
                className="input inputArea"
                variant="outlined"
                size={"medium"}
                name="area"
                onChange={handleChange}
                disabled={ver && true}
              />
            </div>

            <div className="divButtonsItem">{renderButtons()}</div>
          </form>
        </div>
      </div>
    </StyledModalcomponentClientes>
  );
};

export default EquiposModal;
// useEffect(() => {

//   const fetchclientes = async () => {
//     const res = await getClienteOptions();
//     const unidades = res?.data?.map((item) => ({
//       value: item.id,
//       label: item.desc_cli,
//     }));
//     setClientes(unidades);

//     if (datos && !Array.isArray(datos)) {
//       const matchOption = unidades.find(
//         (option) => option.label === datos.cliente
//       );

//       if (matchOption) {
//         setSelectedOptioncli(matchOption);
//       } else {
//         setSelectedOptioncli({ label: datos.cliente, value: datos.clienteId, estado: "eliminado" });
//       }

//     } else if (unidades.length > 0 && editar) {

//     }
//   };
//   fetchclientes();
//   let fetchPlantas;
//   const idSelect = props.datos?.selectedOption?.value
//   if (idSelect) {
//     fetchPlantas = async () => {
//       // if (!selectedOptioncli?.value) return;
//       const res = await getPlantaOptionsByClienteEquipos(!selectedOptioncli?.value);
//       const unidades = Array.isArray(res?.data)
//         ? res.data.map((item) => ({
//           value: item.id,
//           label: item.description,
//           cliente: item.cliente,
//         }))
//         : [];

//       setPlantas(unidades);
//       if (editar || ver) {
//         if (datos && !Array.isArray(datos)) {
//           let matchOption = null;

//           if (form.selectedOption !== "") {
//             matchOption = unidades.find(
//               (option) => option.value === props.datos.selectedOption.value
//             );
//           } else {
//             matchOption = unidades.find(
//               (option) => option.value === datos.plantaId
//             );
//           }

//           if (matchOption) {
//             setSelectedOptionpla(matchOption);
//             setForm({ type: "SET_FIELD", field: "planta", value: matchOption.value });
//             setForm({ type: "SET_FIELD", field: "plantaId", value: matchOption.value });

//             const clienteSeleccionado = {
//               value: matchOption.cliente?.id,
//               label: matchOption.cliente?.description,
//             };

//             setSelectedOptioncli(clienteSeleccionado);
//             setForm({ type: "SET_FIELD", field: "cliente", value: clienteSeleccionado.value });
//           } else {
//             setSelectedOptionpla({
//               label: datos.planta,
//               value: datos.plantaId,
//               estado: "eliminado",
//             });
//           }
//         }
//       } else {

//         if (unidades.length === 0) return;

//         const plantaId = props?.datos?.selectedOption?.value;

//         if (!plantaId) {
//           setSelectedOptionpla({
//             placeholder: "Seleccione el cliente primero",
//             value: null,
//             estado: "disabled",
//           });

//           setSelectedOptioncli(null);

//           setForm({ type: "SET_FIELD", field: "planta", value: null });
//           setForm({ type: "SET_FIELD", field: "plantaId", value: null });
//           setForm({ type: "SET_FIELD", field: "cliente", value: null });
//           return;
//         }

//         const matchOption = unidades.find((option) => option?.value === plantaId);

//         if (matchOption) {
//           setSelectedOptionpla(matchOption);
//           setForm({ type: "SET_FIELD", field: "planta", value: matchOption.value });
//           setForm({ type: "SET_FIELD", field: "plantaId", value: matchOption.value });

//           const clienteSeleccionado = {
//             value: matchOption.cliente?.id,
//             label: matchOption.cliente?.description,
//           };

//           if (clienteSeleccionado.value && clienteSeleccionado.label) {
//             setSelectedOptioncli(clienteSeleccionado);
//             setForm({ type: "SET_FIELD", field: "cliente", value: clienteSeleccionado.value });
//           } else {
//             setSelectedOptioncli({
//               label: datos?.cliente,
//               value: datos?.clienteId,
//               estado: "eliminado",
//             });
//           }
//         } else {
//           setSelectedOptionpla({
//             label: datos?.planta || "Planta desconocida",
//             value: plantaId,
//             estado: "eliminado",
//           });
//         }
//       }
//     };
//   } else {
//     fetchPlantas = async () => {
//       if (!selectedOptioncli?.value) return;
//       const res = await getPlantaOptionsByClienteEquipos(selectedOptioncli?.value);
//       const unidades = res?.data?.map((item) => ({
//         value: item.id,
//         label: item.description,
//         cliente: item.cliente,
//       }));
//       setPlantas(unidades);
//       if (datos && !Array.isArray(datos)) {
//         let matchOption = '';

//         if (form.selectedOption !== "") {
//           matchOption = unidades.find(
//             (option) => option.value === props.datos.selectedOption.value
//           );
//         } else {
//           matchOption = unidades.find(
//             (option) => option.value === datos.plantaId
//           );
//         }

//         if (matchOption) {
//           setSelectedOptionpla(matchOption);
//           setForm({ type: "SET_FIELD", field: "planta", value: matchOption.value });
//           setForm({ type: "SET_FIELD", field: "plantaId", value: matchOption.value });


//           let clienteSeleccionado = {
//             value: matchOption.cliente?.id,
//             label: matchOption.cliente?.description
//           }
//           setSelectedOptioncli(clienteSeleccionado);
//           setForm({ type: "SET_FIELD", field: "cliente", value: clienteSeleccionado.value });
//         } else {
//           setSelectedOptionpla({ label: datos.planta, value: datos.plantaId, estado: "eliminado" });
//         }
//       }
//     };
//   }
//   fetchPlantas();
// }, []);

// useEffect(() => {
//   const fetchClientesYPlantas = async () => {

//     const resClientes = await getClienteOptions();
//     const clientesMapped = resClientes?.data?.map((item) => ({
//       value: item.id,
//       label: item.desc_cli,
//     }));
//     setClientes(clientesMapped);


//     let clienteSeleccionado = null;
//     if (datos?.clienteId) {
//       clienteSeleccionado = clientesMapped.find(c => c.value === datos.clienteId);
//       if (clienteSeleccionado) {
//         setSelectedOptioncli(clienteSeleccionado);
//         setForm({ type: "SET_FIELD", field: "cliente", value: clienteSeleccionado.value });
//       } else {
//         clienteSeleccionado = { label: datos.cliente, value: datos.clienteId, estado: "eliminado" };
//         setSelectedOptioncli(clienteSeleccionado);
//         setForm({ type: "SET_FIELD", field: "cliente", value: clienteSeleccionado.value });
//       }
//     }


//     if (!clienteSeleccionado?.value) return;

//     const resPlantas = await getPlantaOptionsByClienteEquipos(clienteSeleccionado.value);
//     const plantasMapped = resPlantas?.data?.map((item) => ({
//       value: item.id,
//       label: item.description,
//       cliente: item.cliente,
//     })) ?? [];

//     setPlantas(plantasMapped);


//     if (datos?.plantaId) {
//       const matchPlanta = plantasMapped.find(p => p.value === datos.plantaId);
//       if (matchPlanta) {
//         setSelectedOptionpla(matchPlanta);
//         setForm({ type: "SET_FIELD", field: "planta", value: matchPlanta.value });
//         setForm({ type: "SET_FIELD", field: "plantaId", value: matchPlanta.value });
//       } else {
//         setSelectedOptionpla({
//           label: datos.planta,
//           value: datos.plantaId,
//           estado: "eliminado",
//         });
//       }
//     }
//   };

//   fetchClientesYPlantas();
// }, []);